/**
 * @generated SignedSource<<eec2b504c5404bb8315bd91ee8dee68e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PipelineLeadType = "buyer" | "financing" | "sales";
import { FragmentRefs } from "relay-runtime";
export type FeedNewForm_lead$data = {
  readonly __typename: "Lead";
  readonly contact: {
    readonly phoneNumbers: ReadonlyArray<{
      readonly createdAt: string;
      readonly number: string;
      readonly primary: boolean | null;
    }>;
  } | null;
  readonly stage: {
    readonly pipeline: {
      readonly leadType: PipelineLeadType;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityForm_lead">;
  readonly " $fragmentType": "FeedNewForm_lead";
};
export type FeedNewForm_lead$key = {
  readonly " $data"?: FeedNewForm_lead$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedNewForm_lead">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedNewForm_lead",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActivityForm_lead"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LeadStage",
      "kind": "LinkedField",
      "name": "stage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Pipeline",
          "kind": "LinkedField",
          "name": "pipeline",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "leadType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhoneNumber",
          "kind": "LinkedField",
          "name": "phoneNumbers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "number",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Lead",
  "abstractKey": null
};

(node as any).hash = "a2c880ccf75e463e4a269e3f5d58aae5";

export default node;
